import { useParams } from "@tanstack/react-router";

import VStack from "@/components/Layout/VStack";

import { useAppIntegrationContract } from "../_$id/-query";

import AppIntegrationBreadcrumb from "./AppIntegrationBreadcrumb";
import AppIntegrationHeader from "./AppIntegrationHeader";
import AppIntegrationHeaderTabs from "./AppIntegrationHeaderTabs";

export default function Header() {
  const { id } = useParams({ from: "/_staff/app-integrations/$id/_$id" });
  const { data } = useAppIntegrationContract(id);

  return (
    <VStack className="gap-4 px-12 pt-4 shadow-xs bg-background">
      <AppIntegrationBreadcrumb name={data.integratedApp.name} />
      <AppIntegrationHeader
        integratedApp={data.integratedApp}
        integratedTenantName={data.integratedTenantName}
        contract={data.contract}
        isSubordinate={data.isSubordinate}
      />
      <AppIntegrationHeaderTabs
        id={id}
        isSubordinate={data.isSubordinate}
        parentApp={data.parentApp}
      />
    </VStack>
  );
}
